import { Chip, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";

/**
 * Security level chip for MFA method cards.
 * Shows "Most Secure" (green) or "Less Secure" (red) badges.
 *
 * Used by both MfaMethodButton (setup page) and ProfileMfaMethodCard (profile page).
 */
export const MfaSecurityChip = styled(Chip, {
  shouldForwardProp: prop => prop !== "tagVariant",
})<{ tagVariant: "success" | "error" }>(({ theme, tagVariant }) => {
  const color =
    tagVariant === "success" ? theme.palette.success.main : (theme.palette.alertRed?.dark ?? theme.palette.error.dark);
  return {
    ...theme.typography.caption,
    height: theme.spacing(2.25),
    color,
    backgroundColor: alpha(color, 0.1),
    border: `1px solid ${color}`,
    "& .MuiChip-label": {
      paddingLeft: theme.spacing(0.625),
      paddingRight: theme.spacing(0.625),
    },
  };
});
